// modules/megamenu-to-test.js

/**
 * Mega Menu - VERSIONE TEST V2
 * - Fix: Navigazione immediata per L2 senza figli
 * - Fix: Prevenzione chiusura L3 durante il tap (rimozione blur aggressivo)
 * - Improved: Gestione eventi Pointer per isolamento Mouse/Touch reale
 */

export function initMegaMenu() {
    const parents = document.querySelectorAll('.mega-parent');
    if (!parents.length) return;

    let active = null;
    let closeTimer = null;
    let isTouchInput = false;

    // Rileviamo se l'utente usa il touch tramite il tipo di puntatore
    document.addEventListener('pointerdown', (e) => {
        isTouchInput = (e.pointerType === 'touch' || e.pointerType === 'pen');
    }, { passive: true });

    const openPanel = (parent) => {
        clearTimeout(closeTimer);
        if (active && active !== parent) closePanel(active, true);

        const toggle = parent.querySelector('.mega-toggle');
        const panel = parent.querySelector('.mega-panel');
        if (!toggle || !panel) return;

        toggle.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        parent.classList.add('is-open');
        active = parent;
    };

    const closePanel = (parent, immediate = false) => {
        const toggle = parent.querySelector('.mega-toggle');
        const panel = parent.querySelector('.mega-panel');
        if (!toggle || !panel) return;

        const doClose = () => {
            toggle.setAttribute('aria-expanded', 'false');
            panel.setAttribute('aria-hidden', 'true');
            parent.classList.remove('is-open');
            if (active === parent) active = null;
        };

        clearTimeout(closeTimer);
        if (immediate) doClose();
        else closeTimer = setTimeout(doClose, 150);
    };

    parents.forEach(parent => {
        const toggle = parent.querySelector('.mega-toggle');
        const panel = parent.querySelector('.mega-panel');
        if (!toggle || !panel) return;

        // --- GESTIONE HOVER (Solo se NO Touch) ---
        parent.addEventListener('mouseenter', () => {
            if (isTouchInput) return; 
            openPanel(parent);
        });

        const leaveHandler = (e) => {
            if (isTouchInput) return;
            const toEl = e.relatedTarget;
            if (!toEl || (!parent.contains(toEl) && !panel.contains(toEl))) {
                closePanel(parent);
            }
        };

        parent.addEventListener('mouseleave', leaveHandler);
        panel.addEventListener('mouseenter', () => {
            if (!isTouchInput) clearTimeout(closeTimer);
        });
        panel.addEventListener('mouseleave', leaveHandler);

        // --- GESTIONE LIVELLO 2 & 3 ---
        const l2Links = panel.querySelectorAll('.mega-l2-link');
        l2Links.forEach(link => {
            const l2Item = link.closest('.mega-l2-item');
            if (!l2Item) return;

            const l2id = l2Item.dataset.megaL2;
            const hasChildren = panel.querySelector(`.mega-l3[data-parent="${l2id}"]`) !== null;

            const showL3 = () => {
                const allL3 = panel.querySelectorAll('.mega-l3');
                const allL2Items = panel.querySelectorAll('.mega-l2-item');
                allL3.forEach(el => el.classList.remove('is-visible'));
                allL2Items.forEach(i => i.classList.remove('is-active'));
                
                l2Item.classList.add('is-active');
                const targets = panel.querySelectorAll(`.mega-l3[data-parent="${l2id}"]`);
                targets.forEach(el => el.classList.add('is-visible'));
            };

            // Hover (Solo Mouse)
            link.addEventListener('mouseenter', () => {
                if (!isTouchInput) showL3();
            });

            // Focus (Tastiera)
            link.addEventListener('focus', () => {
                showL3();
            });

            // Click / Tap
            link.addEventListener('click', (e) => {
                if (isTouchInput && hasChildren) {
                    const isActive = l2Item.classList.contains('is-active');
                    if (!isActive) {
                        e.preventDefault();
                        showL3();
                    }
                }
                // Se NON ha figli o NON è touch, il browser segue l'HFREF normalmente
            });
        });

        // --- GESTIONE CLICK LIVELLO 1 (Toggle) ---
        toggle.addEventListener('click', (e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

            const isOpen = parent.classList.contains('is-open');

            if (isTouchInput) {
                if (!isOpen) {
                    e.preventDefault();
                    openPanel(parent);
                }
                return;
            }

            if (!isOpen) {
                e.preventDefault();
                openPanel(parent);
            }
        });
    });

    document.addEventListener('click', (e) => {
        if (![...parents].some(p => p.contains(e.target))) {
            parents.forEach(p => closePanel(p, true));
        }
    });
}
